import { render, staticRenderFns } from "./MachineInsights.vue?vue&type=template&id=22b8bffe&scoped=true"
import script from "./MachineInsights.vue?vue&type=script&lang=js"
export * from "./MachineInsights.vue?vue&type=script&lang=js"
import style0 from "./MachineInsights.vue?vue&type=style&index=0&id=22b8bffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8bffe",
  null
  
)

export default component.exports